angular.module('egg.delivery')
    .directive('deliveryItemsDirective', ['$filter', '$document', '$compile', '$parse', 'EggDeliveryItem', 'ModuleSettings', 'EggOrderConst', 'Client', function ($filter, $document, $compile, $parse, EggDeliveryItem, ModuleSettings, EggOrderConst, Client) {
        return {
            restrict: 'AE',
            scope: {
                orderedProduct: '=',
                dueDate: '=',
                onSelect: '&'
            },
            templateUrl: "app/egg/delivery/delivery-items-directive/delivery-items-directive.tpl.html",
            link: function (scope, $element, $attrs) {
                scope.EggOrderConst = EggOrderConst;
                scope.executeOnSelect = scope.onSelect || angular.noop;

                scope.loadEggDeliveryItems = function () {
                    EggDeliveryItem.table(scope.filters).$promise.then(function (result) {
                        scope.deliveryItems = result;
                        scope.sumOfDeliveryItems = result.map(function (item) {
                            return Number(item.stockQuantityLeft);
                        }).reduce(function (previous, current) {
                            return previous + current;
                        }, Number(0));
                    });
                };

                ModuleSettings.get({module: "egg-order"}).$promise.then(function (setting) {
                    scope.productSetting = filteringSetting(setting.filteringSettings, scope.orderedProduct);
                    scope.resetFilters();
                });

                scope.selectDelivery = function (deliveryItem) {
                    scope.executeOnSelect()(deliveryItem);
                };

                scope.resetFilters = function () {
                    scope.filters = {
                        maxDaysToLayingDate: deliveryAndOrderDiffDays(scope.productSetting),
                        stock: 'available-only',
                        dueDate: scope.dueDate,
                        products: productsDeliveryFilter(scope.productSetting)
                    };
                    scope.loadEggDeliveryItems();
                };

                scope.refreshClients = function (q) {
                    Client.autocomplete({q: q}).$promise.then(function (items) {
                        scope.clients = items;
                    });
                };

                scope.switchFiltering = function () {
                    EggOrderConst.filteringActive = !EggOrderConst.filteringActive;
                    scope.filters.products = productsDeliveryFilter(scope.productSetting);
                    scope.loadEggDeliveryItems();
                };

                scope.$on('egg.order-link.updated', function (event, data) {
                    scope.loadEggDeliveryItems();
                });

                function filteringSetting(filteringSettings, systemProduct) {
                    var settingsArray = filteringSettings || [];
                    var products = settingsArray.map(function (s) {
                        return s.product;
                    });
                    var ids = products.map(function (p) {
                        return p.id;
                    });
                    var $i = ids.indexOf(systemProduct.id);
                    if ($i > -1) {
                        return settingsArray[$i];
                    }
                }

                function productsDeliveryFilter(productSettings) {
                    if (productSettings && EggOrderConst.filteringActive)
                        return productSettings.products.map(function (p) {
                            return p.id;
                        });
                    else return [];
                }

                function deliveryAndOrderDiffDays(productSettings) {
                    if (productSettings)
                        return productSettings.deliveryAndOrderDiffDays;
                    else return EggOrderConst.deliveryAndOrderDiffDays;
                }
            }
        };
    }]);
